import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { AuthorityCodeChangeEvent, ViewController } from "@gaming/srvg-classes-core";
import { ChunkIndicatorView } from "../../View/ChunkIndicatorView";

export class ChunkIndicatorViewController extends ViewController {
    /**
     * View to be controlled
     */
    chunkIndicatorView: ChunkIndicatorView;

    constructor( options ) {
        options = options || {};
        options.view = options.chunkIndicatorView || null;
        options.name = options.name || 'chunkIndicatorViewController';

        options.eventsToSubscribe = [
            {
                eventType: PhaseChangeEvent,
                provider: app.timelineController
            }
        ];

        super( options );
        this.chunkIndicatorView = options.chunkIndicatorView || options.view || null;
    }

    // ************************** Event handlers **************************

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        /*            console.log("ChunkIndicatorViewController: handlePhaseChangeEvent, sent by Timeline");
                    //console.log(provider);
                    var chunk = null;
                    if (
                        (event.chunk.competitionStageType == "cup" && event.chunk.nr == 6) &&
        
                        (event.phase.name == "match" || event.phase.name == "overtime" ||
                        event.phase.name == "penalty_shootout" || event.phase.name == "post_match" ||
                        event.phase.name == "post_cup" )
                    ) {
                        console.log("ChunkIndicatorViewController: no chunk.next available");
                            console.log ("ChunkIndicatorViewController: XXX, ", event.phase.name);
                            chunk = event.chunk.next;
                            console.log(chunk);
                    }
                    else {
                        console.log ("ChunkIndicatorViewController: ZZZ, ", event.phase.name);
                        chunk = event.chunk;
                        console.log(chunk);
                    }
        
        */
        if( event.channel == app.timeline.currentChannel ) {
            this.chunkIndicatorView.setChunk( event.chunk );
        }
    }

    handleTimeoutEvent( event, provider ) {
        this.chunkIndicatorView.disable();
        // hide all elements that would still be shown after other elements are already enabled
        this.chunkIndicatorView.ambassadorView.hide();
        this.chunkIndicatorView.sporteventSetView.hide();
        this.chunkIndicatorView.competitionView.hide();
        this.chunkIndicatorView.chunkView.hide();
    }

    handleAuthorityCodeChangeEvent(event: AuthorityCodeChangeEvent, provider){
        this.chunkIndicatorView.setAuthorityCode(event.data.authorityCode);
    }
}